<template>
  <div>
    <md-chip
      v-for="tag in tags"
      :key="tag.id"
      :style="chipStyle(tag.color)"
    >{{ tag.name }}</md-chip>
  </div>
</template>
<script>
export default {
  name: "RecordTag",
  props: {
    recordTag: {
      type: String,
    },
    recordTags: {
      type: Array,
    },
  },
  computed: {
    tags() {
      if (!this.recordTag) return [];

      var parts = this.recordTag && this.recordTag.split(",");
      if (!this.recordTags) {
        return [];
      }

      var res = this.recordTags.filter((t) => parts.includes(t.name)) || [];
      return res;
    },
  },
  methods: {
    chipStyle(color) {
      const bg = color || "darkgray";
      const text = this.contrastingTextColor(bg);
      return `background-color: ${bg} !important; border: 2px solid ${bg}; line-height: normal; color: ${text} !important; display: inline-flex; align-items: center;`;
    },
    contrastingTextColor(hex) {
      if (!hex) return "#fff";
      const c = hex.replace("#", "");
      if (c.length !== 6) return "#fff";
      const r = parseInt(c.substring(0, 2), 16);
      const g = parseInt(c.substring(2, 4), 16);
      const b = parseInt(c.substring(4, 6), 16);
      const luma = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
      return luma > 0.6 ? "#000" : "#fff";
    },
  },
};
</script>
<style></style>
